var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8904 1.22684V22.7732C10.8904 23.5549 10.1764 24.1412 9.42621 23.9702C4.01733 22.7487 0 17.8507 0 12C0 6.14927 4.01733 1.25127 9.42621 0.0298243C9.60294 -0.00895842 9.78604 -0.00717678 9.962 0.0350376C10.138 0.077252 10.3023 0.158821 10.4428 0.273722C10.5834 0.388623 10.6965 0.533922 10.774 0.69889C10.8515 0.863858 10.8912 1.04428 10.8904 1.22684ZM13.3467 1.22684V9.54489C13.3467 10.2167 13.8913 10.7663 14.5568 10.7663H22.773C23.5474 10.7663 24.1282 10.0457 23.9588 9.27617C22.9303 4.68354 19.3606 1.06805 14.823 0.0298243C14.0607 -0.141178 13.3467 0.445116 13.3467 1.22684ZM13.3467 14.4551V22.7732C13.3467 23.5549 14.0607 24.1412 14.823 23.9702C19.3727 22.9319 22.9424 19.3043 23.9709 14.7116C24.1403 13.9543 23.5474 13.2214 22.7851 13.2214H14.5689C13.8913 13.2337 13.3467 13.7833 13.3467 14.4551Z",
    fill: "#FF845E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat);
export default __webpack_public_path__ + "static/media/stat.d29448f4685200eb8edb100cd26c8848.svg";
export { ForwardRef as ReactComponent };